/**
 * @generated SignedSource<<b8896311579b53c790143f00abdcb7f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LineItemGroupType = "BOOKING" | "EVENT_REGISTRATION" | "EVENT_SIGN_UP" | "PLAYER" | "TRANSPORTATION";
export type LineItemType = "BASIC" | "BOOKING" | "EVENT_REGISTRATION" | "EVENT_SIGN_UP" | "NO_SHOW_BOOKING" | "NO_SHOW_ROUND" | "ROUND";
import { FragmentRefs } from "relay-runtime";
export type useGetBookingCharge_Booking$data = {
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly lineItemGroups: ReadonlyArray<{
          readonly id: string;
          readonly lineItems: ReadonlyArray<{
            readonly appliedDiscounts?: ReadonlyArray<{
              readonly amountCents: number | null | undefined;
              readonly squareExternalDiscountId: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly price: number;
            readonly quantity: number;
            readonly total: number;
            readonly type: LineItemType;
          } | null | undefined> | null | undefined;
          readonly type: LineItemGroupType;
        } | null | undefined> | null | undefined;
        readonly orderDiscounts: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly amount: number | null | undefined;
              readonly appliedAmount: number | null | undefined;
              readonly id: string;
              readonly lineItemGroupId: string | null | undefined;
              readonly name: string;
              readonly squareExternalId: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetBookingCharge_Booking";
};
export type useGetBookingCharge_Booking$key = {
  readonly " $data"?: useGetBookingCharge_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetBookingCharge_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AppliedDiscount",
    "kind": "LinkedField",
    "name": "appliedDiscounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "squareExternalDiscountId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetBookingCharge_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LineItemGroup",
                  "kind": "LinkedField",
                  "name": "lineItemGroups",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "lineItems",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "price",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "quantity",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "total",
                          "storageKey": null
                        },
                        (v2/*: any*/),
                        (v1/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": (v3/*: any*/),
                          "type": "BookingLineItem",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v3/*: any*/),
                          "type": "RoundLineItem",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrderDiscountConnection",
                  "kind": "LinkedField",
                  "name": "orderDiscounts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderDiscountEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "OrderDiscount",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "appliedAmount",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "amount",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "squareExternalId",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "lineItemGroupId",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "bb60d8f1971a9da93e3a204e693652b6";

export default node;
